import React from 'react';

import { Spacing } from '@crm-framework/spacing';

import { PlaceholderText } from './styled';

const PLACEHOLDERS = [
  '{link}',
  '{description}',
  '{validTo}',
  '{firstName}',
  '{lastName}',
  '{signature}',
];

export const HelpPlaceholders = () => (
  <>
    <Spacing mt={10}>
      <PlaceholderText>Placeholders</PlaceholderText>
    </Spacing>
    <hr />
    <Spacing mb={10}>
      {PLACEHOLDERS.map((placeholder) => (
        <PlaceholderText key={placeholder}>{placeholder}</PlaceholderText>
      ))}
    </Spacing>
  </>
);
